import { ApolloClient, createHttpLink, InMemoryCache } from '@apollo/client/core';

import { getAppContext } from '@/helpers/get-app-context';

const { DAL_TOKEN } = getAppContext();

const httpLink = createHttpLink({
  headers: {
    authorization: `Bearer ${DAL_TOKEN}`,
  },
  uri: import.meta.env.VITE_DAL_URL,
});

const cache = new InMemoryCache();

export const apolloClient = new ApolloClient({
  cache,
  link: httpLink,
});
